(function () {
  var PREFIX = 'bows_slot_';
  var DAYS = 7;

  function getCookies() {
    var map = {};
    document.cookie.split(';').forEach(function (chunk) {
      var i = chunk.indexOf('=');
      if (i < 0) return;
      var key = chunk.slice(0, i).trim();
      if (key.indexOf(PREFIX) !== 0) return;
      map[key.slice(PREFIX.length)] = chunk.slice(i + 1).trim();
    });
    return map;
  }

  function setCookie(id) {
    var expires = new Date(Date.now() + DAYS * 864e5).toUTCString();
    document.cookie = PREFIX + id + '=' + Date.now() + ';expires=' + expires + ';path=/;SameSite=Lax';
  }

  function openReveal(toggle, reveal, email) {
    toggle.setAttribute('aria-expanded', 'true');
    reveal.hidden = false;
    if (email) {
      email.setAttribute('required', '');
      email.focus();
    }
  }

  function closeReveal(toggle, reveal, email) {
    toggle.setAttribute('aria-expanded', 'false');
    reveal.hidden = true;
    if (email) email.removeAttribute('required');
  }

  function markTaken(slot, toggle) {
    slot.classList.add('slot-taken');
    if (!toggle) return;
    toggle.textContent = slot.getAttribute('data-label-taken') || 'Indisponible';
    toggle.classList.add('slot-pill-taken');
    toggle.removeAttribute('data-slot-toggle');
    toggle.disabled = true;
  }

  function init() {
    var cookies = getCookies();
    var posted = /[?&]contact_posted=true/.test(window.location.search);

    var newestId = null;
    var newestTs = -1;
    Object.keys(cookies).forEach(function (id) {
      var ts = parseInt(cookies[id], 10) || 0;
      if (ts > newestTs) { newestTs = ts; newestId = id; }
    });

    // Fresh booking = posted + newest cookie set in the last 30s (not an old cookie).
    var slotJustBooked = posted && newestId !== null && (Date.now() - newestTs) < 30000;
    if (slotJustBooked) { window.__bowsSlotJustBooked = true; }

    document.querySelectorAll('form [data-slot]').forEach(function (slot) {
      var id = slot.getAttribute('data-slot');
      var form = slot.closest('form');
      var toggle = slot.querySelector('[data-slot-toggle]');
      var reveal = form.querySelector('[data-slot-reveal]');
      var email = form.querySelector('[data-slot-email]');
      var error = form.querySelector('[data-slot-error]');
      var confirmMsg = form.querySelector('[data-slot-confirm-msg]');

      if (cookies.hasOwnProperty(id)) {
        markTaken(slot, toggle);
        if (slotJustBooked && id === newestId && confirmMsg) confirmMsg.hidden = false;
        return;
      }

      if (!toggle || !reveal) return;

      function toggleReveal() {
        if (reveal.hidden) openReveal(toggle, reveal, email);
        else closeReveal(toggle, reveal, email);
      }

      toggle.addEventListener('click', toggleReveal);

      form.addEventListener('submit', function (e) {
        var invalid = !email || !email.value.trim() || !email.checkValidity();
        if (invalid) {
          e.preventDefault();
          openReveal(toggle, reveal, email);
          if (error) error.hidden = false;
          if (email) email.reportValidity();
          return;
        }
        setCookie(id);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
